import React from 'react';

function App(props) {

  var rows = props.rows;
  var headerCells = props.headerCells;
  var addStuff = props.addStuff;

  var headerRow;
  if (headerCells){
    headerRow = <thead>
                <tr>
                  {headerCells.map((aH, index)=>{
                    return <th scope="col">{aH}</th>
                  })}
                </tr>
              </thead>
//
  }

  var tgt = ["table table-hover"];
  if (addStuff){
    tgt = tgt.concat(addStuff);
  }
  return <table className={tgt.concat(' ')}>{headerRow}<tbody>{rows}</tbody></table>    
}

export default App;
